import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

const actionLabelsFr = {
  read: 'Lire',
  edit: 'Modifier',
  delete: 'Supprimer',
  write: 'Créer',
  print: 'Imprimer',
  syncAll: 'Sync tous',
  sync: 'Synchroniser',
  importExcel: 'Importer',
  export: 'Exporter',
  status: 'Statut',
  readOne: 'Détails',
  followAll: 'Suivre tous',
  follow: 'Suivre',
  select: 'Sélectionner',
};

export default function PermissionMenu({ menu, formData, onChangeInput, onToggleAll }) {
  const [isOpen, setIsOpen] = useState(false);

  const hasPermission = (action) => {
    const permKey = `Menu_${menu.name}_${action}`;
    return formData.permission?.includes(permKey);
  };

  const checkedCount = menu.actions.filter(a => hasPermission(a)).length;
  const allChecked = checkedCount === menu.actions.length;
  const someChecked = checkedCount > 0 && !allChecked;

  return (
    <div className="border border-gray-200 rounded-lg bg-white shadow-sm overflow-hidden">
      {/* Header row */}
      <div
        className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setIsOpen(prev => !prev)}
      >
        <div className="flex items-center gap-3">
          <div className={`w-2 h-2 rounded-full ${allChecked ? 'bg-emerald-500' : someChecked ? 'bg-amber-400' : 'bg-gray-300'}`} />
          <span className="font-medium text-gray-900 text-sm">{menu.label}</span>
          <span className="text-xs text-gray-400">{checkedCount}/{menu.actions.length}</span>
        </div>
        <div className="flex items-center gap-2">
          {/* Toggle all button */}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onToggleAll(menu, allChecked); }}
            className={`text-xs px-2 py-0.5 rounded-full border transition-colors ${
              allChecked
                ? 'bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100'
                : 'bg-gray-50 border-gray-200 text-gray-500 hover:bg-gray-100'
            }`}
          >
            {allChecked ? 'Tout retirer' : 'Tout activer'}
          </button>
          {isOpen ? <ChevronUp className="w-4 h-4 text-gray-400" /> : <ChevronDown className="w-4 h-4 text-gray-400" />}
        </div>
      </div>

      {/* Actions grid */}
      {isOpen && (
        <div className="px-4 pb-3 pt-1 border-t border-gray-100">
          <div className="flex flex-wrap gap-2">
            {menu.actions.map((action) => {
              const inputName = `${menu.name}__${action}`;
              const checked = hasPermission(action);
              return (
                <label
                  key={action}
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer border transition-colors select-none ${
                    checked
                      ? 'bg-emerald-50 border-emerald-300 text-emerald-800'
                      : 'bg-gray-50 border-gray-200 text-gray-500 hover:bg-gray-100'
                  }`}
                >
                  <input
                    type="checkbox"
                    name={inputName}
                    checked={checked}
                    onChange={onChangeInput}
                    className="sr-only"
                  />
                  <div className={`w-3.5 h-3.5 rounded-sm border flex items-center justify-center transition-colors ${
                    checked ? 'bg-emerald-500 border-emerald-500' : 'bg-white border-gray-300'
                  }`}>
                    {checked && (
                      <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                  {actionLabelsFr[action] || action}
                </label>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
